//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants() {
        return {
            clientColumnDefs: [
                ['name', true, 'text', r => this.getClientName(r)],
            ],
        };
    },

    methods: {
        getName(item) {
            return `${item.firstName} ${item.lastName}`;
        },
        getNameCell(item) {
            return [
                this.getName(item),
                item.email,
            ];
        },
        getAddressCell(item) {
            return [
                item.street,
                item.city,
            ];
        },
        getClientName(client) {
            this.$refs.master.actualizeRefSkipDirty('clients', client, 'personRef');

            return client.person ? `${client.person.firstName} ${client.person.lastName}` : client.companyName;
        },
        getDrivesForCell(item) {
            return $.clients
                .filter(c => this.isDriverOf(item, c))
                .map(this.getClientName)
                .join(', ');
        },
        getIsContactForCell(item) {
            return $.clients
                .filter(c => this.isContactPersonOf(item, c))
                .map(this.getClientName)
                .join(', ');
        },
        isDriverOf(item, client) {
            return client.driverRefs.includes(item.id);
        },
        isContactPersonOf(item, client) {
            return client.contactPersonRefs?.find(({ id }) => id === item.id);
        },
        textFilterFn(item, text) {
            return !text || $.normalizedIncludes([
                [item.firstName, item.lastName].join(' '),
                item.email,
                item.street,
                item.city,
                this.getDrivesForCell(item),
                this.getIsContactForCell(item),
            ], text);
        },
    },
};
